import React from 'react';
import { AlertCircle, FileText } from 'lucide-react';
import { formatPrice } from './constants';

const FINANCING_LABELS = {
    cash: 'Comptant',
    credit: 'Crédit',
    mixte: 'Mixte',
};

function OfferReviewStep({ form, selectedMandate }) {
    return (
        <div className="space-y-4">
            <div className="p-4 bg-gradient-to-r from-[#681793]/10 to-[#FF914D]/10 border border-[#681793]/20 rounded-xl">
                <p className="text-xs font-bold text-[#FF914D] mb-3 flex items-center gap-2">
                    <AlertCircle className="w-3.5 h-3.5" /> Récapitulatif de l'offre
                </p>
                <div className="space-y-2 text-sm">
                    <div className="flex justify-between">
                        <span className="text-white/40">Bien</span>
                        <span className="text-white font-medium">
                            {selectedMandate?.mandate_number} — {selectedMandate?.address}
                        </span>
                    </div>
                    <div className="flex justify-between">
                        <span className="text-white/40">Prix affiché</span>
                        <span className="text-white">{formatPrice(selectedMandate?.price)} €</span>
                    </div>
                    <div className="flex justify-between border-t border-white/5 pt-2">
                        <span className="text-white/40">Montant offre</span>
                        <span className="text-xl font-black text-[#FF914D]">{formatPrice(form.offer_amount)} €</span>
                    </div>
                    <div className="flex justify-between">
                        <span className="text-white/40">Acquéreur(s)</span>
                        <span className="text-white">
                            {form.buyers.map((b) => `${b.first_name} ${b.last_name}`).join(', ')}
                        </span>
                    </div>
                    <div className="flex justify-between">
                        <span className="text-white/40">Financement</span>
                        <span className="text-white capitalize">
                            {FINANCING_LABELS[form.financing.type] || form.financing.type}
                        </span>
                    </div>
                    <div className="flex justify-between">
                        <span className="text-white/40">Validité</span>
                        <span className="text-white">{form.validity_days} jours</span>
                    </div>
                    {form.conditions.length > 0 && (
                        <div className="border-t border-white/5 pt-2">
                            <p className="text-white/40 mb-1">Conditions suspensives :</p>
                            {form.conditions.map((c) => (
                                <p key={c} className="text-[10px] text-white/50 pl-2">
                                    - {c}
                                </p>
                            ))}
                        </div>
                    )}
                </div>
            </div>

            <div className="p-3 bg-green-500/10 border border-green-500/20 rounded-xl">
                <p className="text-xs text-green-400 font-medium flex items-center gap-2">
                    <FileText className="w-3.5 h-3.5" />
                    En validant, l'offre sera envoyée pour signature électronique conforme eIDAS
                </p>
            </div>
        </div>
    );
}

export default OfferReviewStep;
